import KyError from 'components/Errors/KyError';
import Loading from 'components/Loading';
import FullWidthTemplate from 'components/Templates/FullWidth';
import {useGet} from 'helpers/KyHooks';
import UsersTechStackList from 'pages/public/usersTechStack/List';


export default function UsersTechStackPage() {
    
  const {response, error} = useGet('api/v1/userTechStacks/list');
    
  let body = <Loading />;
  if (response) {
    body = <UsersTechStackList data={response.data.users} />;
  } else if (error) {
    body = <KyError kyError={error} />;
  }
    
  return (
    <FullWidthTemplate title="Ninja Tech Stack Page">
      {body}
    </FullWidthTemplate>
  );
}
